module.exports = __webpack_public_path__ + "82daeca0d6beb27133af47f7882ff4b4.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/toolbox/images/ShapeBasic.png
 ** module id = 3300
 ** module chunks = 0
 **/